let DeviceUtil = require("./DeviceUtil");

let AnnotationUtil = {};

AnnotationUtil.getDescription = function (anno) {
  if (anno.value) {
    if (anno.value.indexOf("SYSTEM:") === 0) {
      let tokens = anno.value.split(":");

      let str = tx(tokens[0] + ":" + tokens[1]);

      if (tokens[2]) {
        str += " (" + tokens[2] + ")";
      }

      return str;
    }

    return anno.value;
  }

  if (anno.event) {
    return anno.event.displayName;
  }

  return tx("N/A");
};

module.exports = AnnotationUtil;
